import React from "react";

import { Link } from "react-router-dom";

import { Row } from "antd";
import Moment from "moment";
import { DATE_FORMAT } from "../../../../../core/utils/i18n-js";
import { AmountText } from "../../../../../core/components/widget/amountInline";

import { InvoiceStatusLabel } from "../../../../../components/invoice/status";
import { LAYOUT_FINANCE_INVOICE_VENDOR_SHOW } from "../../../navigation";

import { DownloadOutlined } from "@ant-design/icons";
import { basicDeleteActionField } from "../../../../../components/table/fields/common";

import { configureField } from "../../../../../core/utils/list";

import { Button } from "antd";

const confirmationMessage = "Are you sure?";

export const basicColumns = (props) => {
    const { isAdmin, loading, filters, resize, hidden } = props;

    if (loading) {
        return [];
    }
    return [
        {
            title: "ID #",
            dataIndex: "display_id",
            ...configureField("i.id", filters, resize, hidden, true, false, false, 200),
            fixed: "left",
            render: (id, record) => <Link to={LAYOUT_FINANCE_INVOICE_VENDOR_SHOW(record.id)}>{id}</Link>,
        },

        {
            title: "Number",
            dataIndex: "number",
            ...configureField("i.number", filters, resize, hidden, true, false, false, 200),
        },
        {
            title: "Vendor",
            dataIndex: "vendor",
            ...configureField("v.name", filters, resize, hidden, true, false, false, 200),
            render: (id, record) => <>{record.vendor?.name}</>,
        },
        {
            title: "Date",
            dataIndex: "date",
            ...configureField("i.date", filters, resize, hidden, true, false, false, 200),
            render: (date) => {
                if (date) return <>{Moment(date).format(DATE_FORMAT)}</>;
            },
        },
        {
            title: "Notes",
            dataIndex: "notes",
            ellipsis: true,
            ...configureField("i.notes", filters, resize, hidden, true, false, true, 200),
        },
        {
            title: "Amount",
            dataIndex: "amount_value",
            ...configureField("i.amountValue", filters, resize, hidden, true, false, true, 200),
            render: (amountValue, record) => {
                return <AmountText value={amountValue} type={record.amount_type} />;
            },
        },
        {
            title: "Status",
            dataIndex: "status",
            ...configureField("i.status", filters, resize, hidden, true, true, true, 200),
            render: (text, record) => {
                return (
                    <Row justify="center">
                        <InvoiceStatusLabel status={text} />
                        {record.attachment && record.attachment.name && (
                            <Button
                                style={{ margin: 0 }}
                                icon={<DownloadOutlined />}
                                size="small"
                                onClick={() => props.downloadInvoice(record.id, record.attachment.name)}
                            />
                        )}
                    </Row>
                );
            },
        },
        {
            ...basicDeleteActionField({ remove: isAdmin ? props.remove : null, loading: props.actionLoading }),
            visible: true,
        },
    ];
};
